module.exports = __webpack_public_path__ + "static/media/icon-billing.a519c075.svg";